/**
 * @param date
 * @param offsetMilliseconds
 * @returns simple arithmatic to get a date adjusted for the difference between a machine's utc offset and a timezone's utc offset
 */
export const getLocalAdjustedDate = (date: Date | null, offsetMilliseconds: number): Date | null => {
  if (!date) return null;

  const timestamp = date.getTime();
  const localAdjustedDate = new Date(timestamp - offsetMilliseconds);

  return localAdjustedDate;
};
